/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Event form instance serializer.
 * @export
 * @interface EventFormInstanceRequest
 */
export interface EventFormInstanceRequest {
    /**
     * 
     * @type {number}
     * @memberof EventFormInstanceRequest
     */
    form: number;
    /**
     * 
     * @type {string}
     * @memberof EventFormInstanceRequest
     */
    event: string;
}

/**
 * Check if a given object implements the EventFormInstanceRequest interface.
 */
export function instanceOfEventFormInstanceRequest(value: object): value is EventFormInstanceRequest {
    if (!('form' in value) || value['form'] === undefined) return false;
    if (!('event' in value) || value['event'] === undefined) return false;
    return true;
}

export function EventFormInstanceRequestFromJSON(json: any): EventFormInstanceRequest {
    return EventFormInstanceRequestFromJSONTyped(json, false);
}

export function EventFormInstanceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventFormInstanceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'form': json['form'],
        'event': json['event'],
    };
}

export function EventFormInstanceRequestToJSON(json: any): EventFormInstanceRequest {
    return EventFormInstanceRequestToJSONTyped(json, false);
}

export function EventFormInstanceRequestToJSONTyped(value?: EventFormInstanceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'form': value['form'],
        'event': value['event'],
    };
}

